import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionHeadingProps {
    id?: string
    eyebrow: string
    title: string
    description?: ReactNode
    align?: 'left' | 'center'
    tone?: 'light' | 'dark'
    className?: string
}

const SectionHeading: FC<SectionHeadingProps> = ({
    id,
    eyebrow,
    title,
    description,
    align = 'left',
    tone = 'light',
    className
}): ReactNode => {
    const dark = tone === 'dark'

    return (
        <div className={cn('max-w-2xl', align === 'center' && 'mx-auto text-center', className)}>
            <p className={cn('font-mono text-xs font-medium uppercase tracking-[0.2em]', dark ? 'text-teal' : 'text-primary')}>
                {eyebrow}
            </p>

            <h2 id={id} className={cn('mt-4 text-3xl font-semibold leading-tight sm:text-4xl lg:text-[2.75rem]', dark ? 'text-white' : 'text-foreground')}>
                {title}
            </h2>

            {description && (
                <p className={cn('mt-4 text-lg leading-relaxed', dark ? 'text-white/65' : 'text-muted-foreground')}>
                    {description}
                </p>
            )}
        </div>
    )
}

export default SectionHeading
